var _defs, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQNav4Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-q-nav-4-selected{fill:#fff;}.cls-2-q-nav-4-selected{fill:#33b0ce;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Diseases-PB-02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-q-nav-4-selected",
    cx: 17,
    cy: 17,
    r: 17
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-q-nav-4-selected",
    cx: 17,
    cy: 17,
    r: 15.59
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix_Group_1868-2",
    "data-name": "prefix  Group 1868-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix_Path_2291-2",
    "data-name": "prefix  Path 2291-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-4-selected",
    d: "M17,25.65c-2.6,0-6.57-3.41-8-6.88a6,6,0,0,1,1.07-6.95,5.16,5.16,0,0,1,3.55-1.47A4.83,4.83,0,0,1,17,11.77a4.93,4.93,0,0,1,7,.05,6,6,0,0,1,1.07,7C23.57,22.24,19.6,25.65,17,25.65Zm-3.45-14a3.62,3.62,0,0,0-2.53,1,4.84,4.84,0,0,0-.84,5.59c1.34,3.22,4.93,6.08,6.82,6.08s5.48-2.86,6.82-6.08a4.81,4.81,0,0,0-.8-5.54,3.61,3.61,0,0,0-5.1-.05l-.46.47a.66.66,0,0,1-.46.19h0a.66.66,0,0,1-.46-.19l-.41-.42a3.59,3.59,0,0,0-2.54-1.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix_Path_2292-2",
    "data-name": "prefix  Path 2292-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-q-nav-4-selected",
    d: "M17.28,20.61h0a.64.64,0,0,1-.59-.46l-.72-2.34-.13.32a.67.67,0,0,1-.6.39H12.1a.65.65,0,1,1,0-1.3h2.69l.67-1.53a.64.64,0,0,1,1.21.07l.7,2.29.26-.61a.64.64,0,0,1,.6-.4H21.9a.65.65,0,1,1,0,1.3H18.66l-.78,1.87A.66.66,0,0,1,17.28,20.61Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQNav4Selected);
export default __webpack_public_path__ + "static/media/q_nav_4_selected.0e4a40ef.svg";
export { ForwardRef as ReactComponent };